import { ChildrenFilter } from '@aibees/elephant/feature/search-filters/filters/children-filter';
import { SearchFilterType } from '@aibees/elephant/feature/search-filters/types';
import { ComingSoonTag } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Card, CardContent, Radio, RadioGroup } from '@mui/material';
import { memo } from 'react';
import { RadioFilterLabel } from '../../../radio-filter/components/radio-filter-label';
import type { RadioGroupFilterItemProps as Props } from './types';

export const RadioGroupFilterItem = memo(
  ({ className, onChange, open, ...item }: Props) => {
    const { field, name, type, metadata } = item;

    return (
      <Card
        className={classnames('RadioGroupFilterItem', className)}
        variant="filled"
        color="default"
      >
        <CardContent padding="normal">
          <RadioGroup>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              gap={1}
              paddingBottom={open ? 1 : 0}
            >
              <RadioFilterLabel value={name}>
                <Radio
                  onChange={(e, checked) => onChange(e, checked, field!, type)}
                  value={field}
                  name={field}
                  checked={open}
                  disabled={item.disabled || item.comingSoon}
                  size="small"
                />
              </RadioFilterLabel>
              {item.comingSoon && <ComingSoonTag />}
            </Box>
          </RadioGroup>
          {type !== SearchFilterType.NOT_AVAILABLE && open && (
            <>
              {type === SearchFilterType.CHECK_BOX ? (
                <Card variant="outlined" color="white">
                  <CardContent padding="normal">
                    <ChildrenFilter open={open} {...item} />
                  </CardContent>
                </Card>
              ) : (
                <ChildrenFilter open={open} {...item} />
              )}
            </>
          )}
        </CardContent>
      </Card>
    );
  }
);

RadioGroupFilterItem.displayName = 'RadioGroupFilterItem';
